import React from 'react';
import { useView } from '../../contexts/ViewContext';
import PressRelease from './PressRelease';
import PressReleaseDetailPage from './PressReleaseDetailPage';
import PressReleaseEditor from './PressReleaseEditor';

const PressReleaseWrapper: React.FC = () => {
  const { view, setView } = useView();

  if (view.subPage === 'detail' && view.id) {
    return <PressReleaseDetailPage pressReleaseId={view.id as string} setView={setView} />;
  }

  if (view.subPage === 'edit' || view.subPage === 'new') {
    return (
      <PressReleaseEditor
        articleId={view.id}
        onBack={() => setView({ page: 'Press Release' })}
        onSuccess={() => setView({ page: 'Press Release' })}
      />
    );
  }

  return <PressRelease setView={setView} />;
};

export default PressReleaseWrapper;
